import React from 'react'
import {Modal} from 'react-bootstrap'
import FeatureSplashContent, {VariantRenderContent} from './FeatureSplashContent'
import {Product} from '../../services/cellcast.v2.types'

type FeatureSplashModalProps = {
  show: boolean
  onClose: () => void
  onActivate: () => void
  title?: string
  description?: React.ReactNode
  isClosable?: boolean
  product?: Product
}

const FeatureSplashModal: React.FC<FeatureSplashModalProps> = ({
  show,
  onClose,
  onActivate,
  title,
  description,
  isClosable = true,
  product,
}) => {
  if (!show) return null

  return (
    <Modal
      show={show}
      onHide={isClosable ? onClose : () => {}}
      dialogClassName='modal-dialog-centered mw-900px'
      backdropClassName='splash-backdrop'
      backdrop={isClosable ? true : 'static'}
      keyboard={isClosable}
      fullscreen={'xxl-down'}
      centered
      animation={true}
      autoFocus
    >
      <FeatureSplashContent
        title={title}
        description={description}
        product={product}
        onActivate={onActivate}
        onClose={onClose}
        showCloseButton={isClosable}
        variant={VariantRenderContent.MODAL}
      />
    </Modal>
  )
}

export default FeatureSplashModal
